export default {
    setWebhookLogsData(state, payload) {
        state.webhookLogsData = payload
    },
    setTotalRecords(state, payload) {
        state.totalRecords = payload
    },
}
